"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _Icon = require("../../Icon/Icon");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    filtersBtn: {
      height: '100%',
      color: palette.link.main
    }
  };
});
/**
 * @callback onSearchChange
 * @param {string} search
 * @returns {void}
 */

/**
 * @callback onSortChange
 * @param {*} sortValue
 * @returns {void}
 */

/**
 * Toolbar for searching, sorting in marketplace and opening filters.
 *
 * @param {object} props
 * @param {string} [props.searchValue='']
 * @param {*} [props.sortValue=undefined]
 * @param {*} [props.defaultSortValue=undefined]
 * @param {onSearchChange} props.onSearchChange
 * @param {onSortChange} props.onSortChange
 * @param {React.ReactNode} props.sortItems
 * @param {function(): void} props.onFiltersOpen
 * @param {boolean} [props.disableSearch=false]
 * @param {boolean} [props.disableSelect=false]
 * @param {boolean} [props.disableFilters=false]
 *
 * @returns {React.ReactElement}
 *
 * @example
 * import { MenuItem } from '@mui/material';
 *
 * export const AwesomeToolbar = () => {
 *   const [search, setSearch] = useState('');
 *   const [sort, setSort] = useState(undefined);
 *   const [isFiltersVisible, setFiltersVisibility] = useState(false);
 *
 *   return (
 *     <MarketplaceToolbar
 *       searchValue={search}
 *       sortValue={sort}
 *       sortItems={[
 *         <MenuItem value="asc">(a-z)</MenuItem>,
 *         <MenuItem value="desc">(z-a)</MenuItem>
 *       ]}
 *       onSortChange={setSort}
 *       onSearchChange={setSearch}
 *       onFiltersOpen={useCallback(() => setFiltersVisibility(true), [])}
 *     />
 *   );
 * };
 */

var MarketplaceToolbar = function MarketplaceToolbar(_ref2) {
  var searchValue = _ref2.searchValue,
      sortValue = _ref2.sortValue,
      defaultSortValue = _ref2.defaultSortValue,
      onSearchChange = _ref2.onSearchChange,
      onSortChange = _ref2.onSortChange,
      sortItems = _ref2.sortItems,
      onFiltersOpen = _ref2.onFiltersOpen,
      disableSearch = _ref2.disableSearch,
      disableSelect = _ref2.disableSelect,
      disableFilters = _ref2.disableFilters;
  var classes = useStyles();
  var searchChangeHandler = (0, _react.useCallback)(function (_ref3) {
    var currentTarget = _ref3.currentTarget;
    onSearchChange(currentTarget.value);
  }, [onSearchChange]);
  var sortChangeHandler = (0, _react.useCallback)(function (_ref4) {
    var target = _ref4.target;
    onSortChange(target.value);
  }, [onSortChange]);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1.9 / 5,
    pr: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    value: searchValue,
    onChange: searchChangeHandler,
    fullWidth: true,
    id: "marketplace-toolbar-textfield",
    placeholder: "Search",
    variant: "outlined",
    disabled: disableSearch,
    InputProps: {
      startAdornment: /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/_react["default"].createElement(_Icon.DashboardIcon, {
        color: "grey",
        icon: "search"
      })),
      endAdornment: /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
        position: "end"
      }, searchValue && /*#__PURE__*/_react["default"].createElement(_material.ButtonBase, {
        onClick: function onClick() {
          return onSearchChange('');
        }
      }, /*#__PURE__*/_react["default"].createElement(_Icon.DashboardIcon, {
        color: "grey.main",
        icon: "times"
      })))
    }
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1.9 / 5,
    pr: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Select, {
    fullWidth: true,
    variant: "outlined",
    id: "marketplace-toolbar-sort-select",
    value: sortValue,
    defaultValue: defaultSortValue,
    onChange: sortChangeHandler,
    disabled: disableSelect
  }, sortItems)), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1.2 / 5
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    className: classes.filtersBtn,
    fullWidth: true,
    variant: "outlined",
    onClick: onFiltersOpen,
    disabled: disableFilters,
    startIcon: /*#__PURE__*/_react["default"].createElement(_Icon.DashboardIcon, {
      icon: "sliders-h"
    })
  }, "Filters")));
};

MarketplaceToolbar.propTypes = {
  onFiltersOpen: _propTypes["default"].func,
  onSearchChange: _propTypes["default"].func.isRequired,
  onSortChange: _propTypes["default"].func.isRequired,
  searchValue: _propTypes["default"].string,
  sortItems: _propTypes["default"].node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  sortValue: _propTypes["default"].any,
  // eslint-disable-next-line react/forbid-prop-types
  defaultSortValue: _propTypes["default"].any,
  disableSearch: _propTypes["default"].bool,
  disableSelect: _propTypes["default"].bool,
  disableFilters: _propTypes["default"].bool
};
MarketplaceToolbar.defaultProps = {
  onFiltersOpen: undefined,
  searchValue: '',
  sortValue: undefined,
  defaultSortValue: undefined,
  disableSearch: false,
  disableSelect: false,
  disableFilters: false
};

var _default = /*#__PURE__*/(0, _react.memo)(MarketplaceToolbar);

exports["default"] = _default;